const translations = {
  navigation: {
    menu: {
      nb: 'Meny',
      da: 'Menu',
      en: 'Menu',
      de: 'Menü',
    },
    loggedIn: {
      myAccount: {
        nb: 'Min side',
        da: 'Min side',
        en: 'My account',
        de: 'Mein Konto',
      },
      loggedInAs: {
        nb: 'Du er logget inn som:',
        da: 'Du er logget ind som:',
        en: 'You are logged in as:',
        de: 'Sie sind angemeldet als:',
      },
      myPage: {
        nb: 'Min side',
        da: 'Min side',
        en: 'My page',
        de: 'Meine Seite',
      },
      logout: {
        nb: 'Logg ut',
        da: 'Log ud',
        en: 'Log out',
        de: 'Ausloggen',
      },
      updatePassword: {
        nb: 'Endre passord',
        da: 'Skift adgangskode',
        en: 'Change password',
        de: 'Passwort ändern',
      },
    },
    search: {
      placeholder: {
        nb: 'Søk her',
        da: 'Søg her',
        en: 'Search here',
        de: 'Suche hier',
      },
    },
  },
  errorPage: {
    title: {
      nb: 'Noe gikk galt',
      da: 'Noget gik galt',
      en: 'Something went wrong',
      de: 'Etwas ist schief gelaufen',
    },
    ingress: {
      nb: 'Vi ser på problemet, prøv igjen om noen minutter',
      da: 'Vi ser på problemet, prøv igen om nogle minutter',
      en: 'We are looking into the problem, please try again in a few minutes',
      de: 'Wir untersuchen das Problem, versuchen Sie es in ein paar Minuten erneut',
    },
    backToFrontPage: {
      nb: 'Tilbake til forsiden',
      da: 'Tilbage til forsiden',
      en: 'Back to front page',
      de: 'Zurück zur Startseite',
    },
  },
}

export default translations
